import React from "react";
import {store} from '@redux/store';
import actions from '@redux/EditableTable/actions';
import EquipmentLookup from "@containers/Lookup/EquipmentLookup";
import { formatWorkorderRef } from "@/utils/entity-ref";

import _ from "lodash";

import moment from "moment";
import ProjectLookup2 from "@containers/Lookup/ProjectLookup2";
import { Badge, Input } from "antd";
import RelatedWorkorderNotification from "@containers/facility/Equipment/RelatedWorkorder/RelatedWorkorderNotification";
import WorkorderLink from "@containers/facility/Workorder/WorkorderLink";
import {
    WORKORDER_STATUS_THEME,
} from "@containers/facility/Workorder/WorkorderColumns";
import {
    getWorkOrderDomainDefault,
    getWorkOrderDomainValueEnum,
    getWorkOrderStatusValueEnum,
} from "@/services/semanticCapabilities";

const {TextArea} = Input;

const formatRelatedWorkorderDate = (value) => {
    if (value == null || value === "") return "-";
    const date = moment(value);
    return date.isValid() ? date.format("YYYY-MM-DD") : "-";
};

const getRelatedName = (value) => {
    if (typeof value === "string") return value;
    return value?.name || "-";
};

export const RelatedWorkorderProps = {
    title: 'Workorder',
    description: '',
    name: 'workorder'
}

export const RelatedWorkorderColumns = () => ( [
    {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        editable: false,
        search: false,
        importIngore: true,
        hideInTable: false,
        width: 80,
        render: (value) => formatWorkorderRef(value)
    },
    // {
    //     title: 'System',
    //     dataIndex: 'system',
    //     key: 'system',
    //     search: false,
    //     edit: true,
    //     hideInTable: window.innerWidth < 760,
    //     sorter: (a, b) => a.system?.localeCompare(b.system),
    //     formItemProps: {
    //         rules: [
    //             {
    //                 required: true,
    //                 message: 'required',
    //             },
    //         ],
    //     },
    //     renderFormItem: () => <TextArea rows={1}/>,
    // },
    {
        title: 'Equipment',
        dataIndex: 'equipment_name.name',
        key: 'equipment_name.name',
        edit: true,
        hideInTable: true,
        type: 'select',
        valueType: 'select',
        sorter: (a, b) => {
            const an =
                typeof a.equipment_name === "string"
                    ? a.equipment_name
                    : _.get(a, "equipment_name.name") || "";
            const bn =
                typeof b.equipment_name === "string"
                    ? b.equipment_name
                    : _.get(b, "equipment_name.name") || "";
            return String(an).localeCompare(String(bn));
        },
        render: (text, record) => {
            const name =
                typeof record.equipment_name === "string"
                    ? record.equipment_name
                    : _.get(record, "equipment_name.name");
            return name || "-";
        },
        renderFormItem: () => <EquipmentLookup/>
        // renderFormItem: (_, { isEditable }) => {
        //     let value = _.entity.equipment
        //     return <EquipmentLookup value={value}/>
        // },
    },
    {
        title: 'Equipment',
        dataIndex: 'equipment',
        key: 'equipment',
        edit: true,
        width: 100,
        type: 'select',
        valueType: 'select',
        sorter: (a, b) => {
            const an =
                typeof a.equipment_name === "string"
                    ? a.equipment_name
                    : _.get(a, "equipment_name.name") || "";
            const bn =
                typeof b.equipment_name === "string"
                    ? b.equipment_name
                    : _.get(b, "equipment_name.name") || "";
            return String(an).localeCompare(String(bn));
        },
        hideInTable: window.innerWidth < 760,
        render: (text, record) => {
            const name =
                typeof record.equipment_name === "string"
                    ? record.equipment_name
                    : _.get(record, "equipment_name.name");
            return name || "-";
        },
        renderFormItem: (_, {isEditable}) => {
            const en = _.entity.equipment_name;
            const recordLabel =
                typeof en === "string" ? en : en?.name || "";
            return <EquipmentLookup record={recordLabel}/>
        },
    },

    {
        title: 'Issue',
        dataIndex: 'issue',
        key: 'issue',
        width: 200,
        search: false,
        edit: true,
        sorter: (a, b) => a.issue?.localeCompare(b.issue),
        formItemProps: {
            rules: [
                {
                    required: true,
                    message: 'required',
                },
            ],
        },
        render: (text, record, _, action) => (
            <WorkorderLink id={record.id} text={text} action={action} />
        ),
        renderFormItem: () => <TextArea rows={1}/>,
    },
    {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        width: 200,
        edit: true,
        required: false,
        search: false,
        hideInTable: false,
        renderFormItem: () => <TextArea rows={1}/>,
    },
    {
        title: 'Recommended Action',
        dataIndex: 'recommended_action',
        key: 'recommended_action',
        edit: true,
        width: 100,
        hideInTable: window.innerWidth < 760,
        sorter: (a, b) => a.recommended_action.localeCompare(b.recommended_action),
        renderFormItem: () => <TextArea rows={1}/>,
    },
    {
        title: 'Responsible Party',
        dataIndex: 'responsible_party',
        key: 'responsible_party',
        edit: true,
        width: 80,
        hideInTable: window.innerWidth < 760,
        sorter: (a, b) => a.responsible_party?.localeCompare(b.responsible_party),
    },
    {
        title: 'WorkOrder Number',
        dataIndex: 'workordernumber',
        key: 'workordernumber',
        width: 80,
        search: false,
        edit: true,
        sorter: (a, b) => a.workordernumber?.localeCompare(b.workordernumber),
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        edit: true,
        width: 100,
        align: 'left', // 状态列左对齐
        render: (text, record) => {
            const statusText = record?.status;
            const theme = WORKORDER_STATUS_THEME[statusText];

            return (
                <div style={theme ? {color: theme.color} : {}}>
                    {statusText}
                </div>
            );
        },
        sorter: (a, b) => a.status?.localeCompare(b.status),
        valueEnum: getWorkOrderStatusValueEnum(),
        formItemProps: {
            initialValue: ''
        },
    },
    {
        title: 'Priority',
        dataIndex: 'priority',
        key: 'priority',
        width: 80,
        edit: true,
        hideInTable: window.innerWidth < 760,
        align: 'left', // 状态列左对齐
        sorter: (a, b) => a.priority?.localeCompare(b.priority),
        render: (text, record) => {
            let bgColor = '';
            let statusText = record?.priority;
            if (statusText === 'Urgent') {
                bgColor = 'text-red-500 ';
            }

            return (
                <div className={`${bgColor} py-1 px-2`}>
                    {statusText}
                </div>
            );
        },
        valueEnum: getWorkOrderDomainValueEnum("priority"),
        formItemProps: {
            initialValue: getWorkOrderDomainDefault("priority")
        },
    },
    {
        title: 'Energy Impact',
        dataIndex: 'energy_impact',
        key: 'energy_impact',
        editable: false,
        hideInTable: true,
    },
    {
        title: 'Assign To',
        dataIndex: 'assignTo_name',
        key: 'assignTo_name',
        editable: false,
        hideInTable: true,
    },
    {
        title: 'Project',
        dataIndex: 'project_name',
        key: 'project',
        editable: false,
        hideInTable: true,
        render: (text, record) => getRelatedName(record.project_name),
    },
    {
        title: 'Complete Date',
        dataIndex: 'complete_date',
        key: 'complete_date',
        editable: false,
        hideInTable: true,
        render: (text, record) => formatRelatedWorkorderDate(record.complete_date),
    },
    {
        title: 'Report Date',
        dataIndex: 'reportDate',
        key: 'reportDate',
        editable: false,
        hideInTable: true,
        render: (text, record) => formatRelatedWorkorderDate(record.reportDate),
    },
    {
        title: 'Due Date',
        dataIndex: 'due_date',
        key: 'due_date',
        editable: false,
        hideInTable: true,
        render: (text, record) => formatRelatedWorkorderDate(record.due_date),
    },
    {
        title: 'Reported By',
        dataIndex: 'reportBy',
        key: 'reportBy',
        editable: false,
        hideInTable: true,
    },
    {
        title: 'Created Date',
        dataIndex: 'created_date',
        key: 'created_date',
        editable: false,
        hideInTable: true,
        render: (text, record) => formatRelatedWorkorderDate(record.created_date),
    },
    // {
    //     title: 'Project',
    //     dataIndex: 'project_name',
    //     key: 'project',
    //     edit: true,
    //     width: 100,
    //     type: 'select',
    //     valueType: 'select',
    //     hideInTable: false,
    //     render: (text, record) => _.get(record, 'project_name.name'),
    //     renderFormItem: (_, {isEditable}) => {
    //         let record = _.entity.project_name ? _.entity.project_name.name : ''
    //         return <ProjectLookup2 record={record}/>
    //     },
    // },
    // {
    //     title: 'Complete Date',
    //     dataIndex: 'complete_date',
    //     edit: true,
    //     type: 'date',
    //     width: 90,
    //     hideInTable: false,
    //     className: 'date-editor',
    //     key: 'complete_date',
    //     sorter: (a, b) => a.complete_date?.localeCompare(b.complete_date),
    //     renderFormItem: () => <Input type={'date'}/>,
    //
    // },
    // {
    //     title: 'Reported By',
    //     dataIndex: 'reportBy',
    //     hideInTable: false,
    //     width: 90,
    //     className: 'date-editor',
    //     key: 'reportBy',
    //     renderFormItem: () => <Input/>,
    // },
    // {
    //     title: 'Report Date',
    //     dataIndex: 'reportDate',
    //     edit: true,
    //     type: 'date',
    //     width: 90,
    //     hideInTable: window.innerWidth < 760,
    //     className: 'date-editor',
    //     key: 'reportDate',
    //     sorter: (a, b) => a.reportDate?.localeCompare(b.reportDate),
    //     renderFormItem: () => <Input type={'date'}/>,
    //
    // },
    // {
    //     title: 'Report Date',
    //     dataIndex: 'reportDate',
    //     hideInTable: true,
    //     className: 'date-editor',
    //     key: 'reportDate',
    // },
    // {
    //     title: 'Modified Date',
    //     dataIndex: 'modified_date',
    //     key: 'modified_date',
    //     width: 90,
    //     editable: false,
    //     search: false,
    //     sorter: (a, b) => a.modified_date - b.modified_date,
    //     hideInTable: window.innerWidth < 760,
    //     importIngore: true,
    //     render: (text, record) => (
    //         moment(record.modified_date).format('YYYY-MM-DD')
    //     )
    // },
    // {
    //     title: 'Created Date',
    //     dataIndex: 'created_date',
    //     key: 'created_date',
    //     width: 90,
    //     hideInTable: false,
    //
    //     editable: false,
    //     importIngore: true,
    //     sorter: (a, b) => a.created_date - b.created_date,
    //     render: (text, record) => (
    //         moment(record.created_date).format('YYYY-MM-DD')
    //     )
    // },

    {
        title: 'Comments',
        key: 'Comments',
        valueType: 'option',
        width: 50,
        importIngore: true,
        render: (text, record, _, action) => (
            <div className="space-around flex item-center">

                <RelatedWorkorderNotification record={record}/>
                {record?.attachment_count > 0 ? <Badge count={record?.attachment_count}>
                    <i className="fas fa-paperclip text-primary text-2xl "
                       style={{color: 'green', fontSize: '23px'}}></i>
                </Badge> : ''}
            </div>
        ),
    },
    {
        title: 'createdby_name',
        dataIndex: 'createdby_name',
        key: 'createdby_name',
        editable: false,
        search: false,
        importIngore: true,
        hideInTable: true,
    },
    {
        title: 'lastModified_name',
        dataIndex: 'lastModified_name',
        key: 'lastModified_name',
        editable: false,
        search: false,
        importIngore: true,
        hideInTable: true,
    },
    {
        title: 'modified_date',
        dataIndex: 'modified_date',
        key: 'modified_date',
        editable: false,
        search: false,
        importIngore: true,
        hideInTable: true,
        align: 'right', // 时间列右对齐（虽然隐藏，但保持一致性）
    },
]);

